<template>
  <container
    :subHeaderTitle="serviceType"
    subHeaderText="휴대폰으로 전송된 인증번호를 입력해주세요."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>인증번호</p>
              <div class="d-flex">
                <v-text-field
                  v-if="teleCoCd == '3'"
                  ref="certNum"
                  label="인증번호 입력"
                  mask="########"
                  :rules="rules.certNumLgTRules"
                  v-model="certNum"
                  v-bind:suffix="countdown"
                  required
                  solo
                />
                <v-text-field
                  v-else
                  ref="certNum"
                  label="인증번호 입력"
                  mask="#####"
                  :rules="rules.certNumRules"
                  v-model="certNum"
                  :suffix="countdown"
                  required
                  solo
                />
                <v-btn large depressed class="ml-2 resend" @click.stop="sendSmsCert"
                :data-ga-category="gaEvent.category.support.safeguard.cert.name" :data-ga-label="gaEvent.category.support.safeguard.cert.label1" :data-ga-action="gaEvent.actions.buttonClick"
                >재전송</v-btn>
              </div>
              <div class="pl-5 mt-2 mb-12">
                <ul>
                  <li>인증번호는 3분 이내에 입력하셔야 합니다.</li>
                  <li>인증시간이 초과하면 재전송하여 인증하시기 바랍니다.</li>
                </ul>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit"
                :data-ga-category="gaEvent.category.support.safeguard.cert.name" :data-ga-label="gaEvent.category.support.safeguard.cert.label2" :data-ga-action="gaEvent.actions.buttonClick"
                >확인</v-btn>
              </div>
              <div class="text-center mt-3">
                <!-- <v-btn class="back" text rounded @click.stop="$router.go(-1)">취소</v-btn> -->
                <v-btn class="back" text rounded @click.stop="goBack"
                :data-ga-category="gaEvent.category.support.safeguard.cert.name" :data-ga-label="gaEvent.category.support.safeguard.cert.label3" :data-ga-action="gaEvent.actions.buttonClick"
                >취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 인증번호 인증 실패 -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>인증번호가 일치하지 않습니다.<br />전송된 인증번호를 확인해보세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="dialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 처리 프로그레스 -->
    <v-dialog v-model="progressDialog" persistent max-width="100">
      <v-card>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- 처리결과 다이얼로그 -->
    <v-dialog v-model="resultDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적으로 처리되지 않았습니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goNext()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- router Param 없을때 -->
    <!-- <v-dialog v-model="returnDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적인 접근이 아닙니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goReturn()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!-- 시간제한 지났을때 -->
    <v-dialog v-model="countDownOverDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>인증시간이 초과했습니다.<br />인증번호를 재전송하여 인증해주세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="countDownOverDialog = !countDownOverDialog">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    
    <!-- KT 회원가입 여부 체크 -->
    <v-dialog v-model="visibleJoin" persistent max-width="263" content-class="base-alert-dialog">
      <div class="base-alert-dialog--inner">
        <div class="base-alert-dialog--content">
          <div style="margin-bottom: 24px;">
            <img src="@/assets/img/img-pass.png" style="width: 72px; height: 72px; margin: 0 auto;" />
          </div>
          <p>PASS 가입 후 휴대폰 인증을<br/>재시도 해주세요.</p>
          <div style="margin-top: 24px;">
            <button type="type" style="font-weight: 500; font-size: 14px; color: #4d3dd3; text-decoration: underline;" @click="handlePreviewOpen">세이프가드 미리보기</button>
          </div>
        </div>
        <div class="base-alert-dialog--buttons">
          <a :href="url" target="_blank" class="base-alert-dialog--button" @click="handleConfirm">PASS 가입하기</a>
        </div>
      </div>
    </v-dialog>
    
    <!-- 미리보기 -->
    <v-dialog v-model="visiblePreview" persistent content-class="preview-dialog">
      <button type="button" class="preview-dialog__close-btn" @click="handleJoinClick">
        <IconClose />
      </button>
      <v-card class="preview-dialog--inner rounded-16">
        <v-card-text class="preview-dialog--content">
          <div class="preview-header">
            <p class="preview-header__title">최근 12 개월의 금융기관 조회이력을<br />확인할 수 있습니다.</p>
            <p class="preview-header__desc">세이프가드 유료 서비스 화면 예시입니다.</p>
          </div>
          <div class="preview-content">
            <swiper class="swiper" :options="swiperOption">
              <swiper-slide>
                <div class="preview-detail">
                  <div class="sample-list-header">
                    <p class="sample-list-title">최근 금융거래 내역</p>
                  </div>
                  <div class="sample-list-picker-wrapper">
                    <div class="picker-example">
                      {{ today }} <span class="picker-example__ico"><IconArrow /></span>
                    </div>
                    <div class="list-counter-example">전체 10건</div>
                  </div>
                  <div class="list">
                    <div class="list-item" v-for="(data, index) in sampleHistoryList" :key="index">
                      <span class="list-item-date">{{ formatDate(data.searchDtm, 'M.DD') }}</span>
                      <div class="list-item-contents">
                        <strong class="list-item-title">{{ data.cpName }}</strong>
                        <ul class="list-item-info">
                          <li>{{ data.procPurpose }}</li>
                          <li>{{ formatDate(data.searchDtm, 'HH:mm') }}</li>
                        </ul>
                      </div>
                      <div class="list-item-handler">
                        <i class="list-item-icon list-chevron-down"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="preview-detail">
                  <div class="monitoring-sample-wrapper">
                    <div class="monitoring-info-wrap">
                      <section class="monitoring-info">
                        <div class="monitoring-info-hero">
                          <IconMoon />
                        </div>
                        <div class="monitoring-info-desc">
                          <p>
                            심야에 이뤄지는 금융거래와 <br />
                            정보변경을 주의하세요
                          </p>
                          <h1>주의거래 모니터링</h1>
                        </div>
                      </section>
                    </div>
                    <div class="monitoring-contents-wrap">
                      <section class="monitoring-list-wrap">
                        <div class="monitoring-none-data">
                          <figure class="safeguard-wrap">
                            <!--                          <Lottie :data="lottieData" style="width: 34px; height: 34px" />-->
                            <figcaption class="text no-wrap" style="white-space: nowrap">금융거래 보호중</figcaption>
                          </figure>
                          <p class="desc">
                            모니터링 서비스는 가입일 이후부터 발생한<br />심야거래, 정보변경 거래 이력을 모니터링하여<br />제공합니다.
                          </p>
                          <p class="add-desc">
                            부가서비스 해지 후 재가입 시<br />
                            이전 모니터링 이력은 제공되지 않습니다.
                          </p>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div class="monitoring-warning-wrapper">
                    <div class="monitoring-notice-slide">
                      <h2>심야에 발생한 거래는<br />각별한 주의가 필요합니다</h2>
                      <div class="img-wrap">
                        <img src="@/assets/img/img_monitor_warning_1.png" />
                      </div>
                      <p>파밍, 해킹 등 금융사기 피해는<br />심야시간에 많이 발생 합니다.</p>
                      <div class="dot-wrapper">
                        <div class="dot active"></div>
                        <div class="dot"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="preview-detail">
                  <div class="sample-reward-wrapper">
                    <div class="reward-info">
<!--                      <h1 class="reward-info-title">세이프가드<br />손실 보상 패키지</h1>-->
<!--                      <div class="reward-summary">-->
<!--                        <h3 class="reward-summary__title">보상<br />알아보기</h3>-->
<!--                        <p class="reward-summary__text">-->
<!--                          발생 손실액 기준 200만원 한도 보상<br />-->
<!--                          보상금액 공동분담비율 10% <br />-->
<!--                          피싱/스미싱 사기에 1:1 전문가 배치<br />-->
<!--                          유료가입 1개월 후 보상 적용-->
<!--                        </p>-->
<!--                      </div>-->
                      <div class="reward-info-inner">
                        <img src="@/assets/img/img_reward_info.png" />
                      </div>
                    </div>
                    <h1 class="notice-title">
                      <span>보상 신청 절차</span>
                      <IconArrow class="notice-title-ico" />
                    </h1>
                    <section class="reward-steps" ref="steps">
                      <div class="steps-transition">
                        <ol class="reward-steps-list steps-transition-path">
                          <li class="reward-steps-item" v-for="(step, index) in sampleStepList" :key="step.id">
                            <div class="num">
                              step<span>{{ index + 1 }}</span>
                            </div>
                            <p v-html="step.text"></p>
                          </li>
                        </ol>
                      </div>
                    </section>
                  </div>
                </div>
              </swiper-slide>
              <div class="sample-swiper-btn-prev" slot="button-prev">
                <IconArrow />
              </div>
              <div class="sample-swiper-btn-next" slot="button-next">
                <IconArrow />
              </div>
            </swiper>
          </div>
          <div class="preview-ctn">
            <a :href="url" target="_blank" class="preview-ctn__button" @click="handleJoinClick">PASS 가입하기</a>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeGuardCert from "@/views/csCenter/PassSafeGuardCert.vue";
import { CONSTANS } from "@/const/index.js";
import { generateSHA256Hash, formater } from "@/mixins/index.js";

import moment from 'moment';
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper.scss";
import IconArrow from "@/components/IconArrow.vue";
import IconMoon from "@/components/IconMoon.vue";
import IconClose from "@/components/IconClose.vue";

export default {
  mixins: [PassSafeGuardCert, generateSHA256Hash, formater],
  name: "PassSafeGuardCert",
  components: {
    Container,
    Swiper,
    SwiperSlide,
    IconArrow,
    IconMoon,
    IconClose
  },
  data() {
    return {
      url: this.getPlatform(),
      swiperOption: {
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: '.sample-swiper-btn-next',
          prevEl: '.sample-swiper-btn-prev'
        }
      },
      sampleHistoryList: [
        {
          searchDtm: '202310130720',
          cpName: '**은행',
          procPurpose: '대출 신청'
        },
        {
          searchDtm: '202308101328',
          cpName: '**카드',
          procPurpose: '카드 발급'
        },
        {
          searchDtm: '202208101158',
          cpName: '**카드',
          procPurpose: '기타 서비스'
        },
        {
          searchDtm: '202208100935',
          cpName: '**카드주식회사',
          procPurpose: '정보 변경'
        },
        {
          searchDtm: '202208100812',
          cpName: '**은행',
          procPurpose: '카드 발급'
        },
        {
          searchDtm: '202208091628',
          cpName: '**카드',
          procPurpose: '기타 서비스'
        },
        {
          searchDtm: '202208091328',
          cpName: '**카드',
          procPurpose: '카드 발급'
        }
      ],
      sampleStepList: [
        {
          id: '1',
          text: '<strong>금융기관 고객센터 연락</strong><br/>사실관계 확인'
        },
        {
          id: '2',
          text: '금융사기 확인 시<br/><strong>지급정지 요청</strong>'
        },
        {
          id: '3',
          text: '<strong>사건사고 사실확인원 발급</strong><br/>(관할 경찰서 민원실)'
        },
        {
          id: '4',
          text: '해당 금융기관에<br/><strong>사실 확인원 제출 및 환급신청</strong>'
        },
        {
          id: '5',
          text: '금전손실 발생 시,<br/><strong>세이프가드에 보상신청</strong>'
        }
      ],
      visiblePreview: false,
      visibleJoin: false
    }
  },
  computed: {
    serviceType() {
      return this.type === "contract" ? "세이프가드·금융사기방지<br /><b>가입하기</b>" : "세이프가드·금융사기방지<br /><b>해지하기</b>";
    },
    today() {
      const date = new Date();
      return `${date.getFullYear()}년 ${date.getMonth() + 1}월`;
    }
  },
  methods: {
    getPlatform() {
      const userAgent = navigator.userAgent?.toLowerCase();

      if (/ipad|iphone|ipod|macintosh/.test(userAgent)) {
        return "https://apps.apple.com/kr/app/pass-by-kt/id1134371550";
      }
      return "https://play.google.com/store/apps/details?id=com.kt.ktauth&hl=KR";
    },
    submit(e) {
      this.gaTracking(e);
      this.$refs.form.validate();
      if (!this.valid) {
        return false;
      }
      this.progressDialog = true;
      
      if (this.countdown === "0:00") {
        this.progressDialog = false;
        this.countDownOverDialog = true;
        return false;
      } 
      
      // 가입 / 해지
      this.axios
        .post("/rest/chanCust", {
          type: this.type,
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo,
          birth: this.birth,
          genCd: this.genCd,
          name: this.name,
          certNum: this.certNum,
          prdtNo: this.prdtNo,
          agreeYn: this.agreeYn,
          ansuranceAgreeYn: this.ansuranceAgreeYn,
          mvnoYn: this.mvnoYn,
        })
        .then((result) => {
          this.progressDialog = false;
          if (result.data.resultCd === "S0000") {
            const date = this.formatDate(new Date(), "YYYYMMDDHHmmssSSS");

            if (this.type === "contract") {
              this.$gtag.purchase({
                transaction_id: this.generateSHA256Hash(this.cellTelNo) + date,
                value: CONSTANS.SG_PRICE,
                currency: "KRW",
                items: [
                  {
                    item_id: CONSTANS.SG_CHAN_CD,
                    item_name: CONSTANS.SG_CHAN_CD,
                    item_variant: CONSTANS.TELE_CO_CD_NM[this.teleCoCd]
                  }
                ]
              });
            }
            this.$router.push({
              name: "PassSafeGuardResult",
              params: {type: this.type, result: "SUCCESS"}
            });
          } else if (result.data.resultCd === "E4221") {
            this.visibleJoin = true;
          } else if (result.data.resultCd === "E9990") {
            this.dialog = true;
          } else {
            this.goNext();
          }
        })
        .catch((result) => {
          this.progressDialog = false;
          this.goNext();
        });
    },
    goNext() {
      this.resultDialog = false;
      this.$router.push({ name: "PassSafeGuardResult", params: { type: this.type, result: "FAIL" } });
    },
    goReturn() {
      this.$router.push({ name: "PassSafeguardCs" });
    },
    goBack(e) {
      this.gaTracking(e);
      this.$router.go(-1);
    },
    handleJoinClick() {
      this.visiblePreview = false;
    },
    handlePreviewOpen() {
      this.visibleJoin = false;
      this.visiblePreview = true;
    },
    handleConfirm() {
      this.visibleJoin = false;
    },
    formatDate(value, format = 'YYYYMMDD') {
      if (!value) return '';
      return moment(value, 'YYYYMMDDHHmmssSSS').format(format);
    }
  }
};
</script>